import { CheckCircleIcon, ExclamationCircleIcon, InformationCircleIcon } from '@heroicons/react/24/solid';
import { classnames } from '@/utils/classnames/classnames';
import { toast as ReactToast } from 'react-hot-toast';
import { GetToast, GetToastOptions, ToastThemeRef } from '../types';

const toastThemeRef: ToastThemeRef = {
  info: { backgroundColor: '#EAF2FC', fill: 'fill-blue-500', icon: InformationCircleIcon },
  success: { backgroundColor: '#EEFBF6', fill: 'fill-green-500', icon: CheckCircleIcon },
  warning: { backgroundColor: '#FEF9EB', fill: 'fill-yellow-500', icon: ExclamationCircleIcon },
  error: { backgroundColor: '#FAEEEE', fill: 'fill-red-500', icon: ExclamationCircleIcon },
};

const getToastDuration = (length: number) => (length >= 120 ? 5000 : 3000);

export const getToastOptions: GetToastOptions = (letters, variant, options) => {
  const Icon = toastThemeRef[variant].icon;

  return {
    style: {
      backgroundColor: toastThemeRef[variant].backgroundColor,
    },
    icon: <Icon className={classnames('size-6 stroke-white stroke-[0.5px]', toastThemeRef[variant].fill)} />,
    duration: getToastDuration(letters),
    // EWM-600 — default every toast to top-right so placement is consistent.
    // react-hot-toast positions per-toast and does NOT inherit the <Toaster>
    // `position` prop when a toast omits its own, so call sites that didn't pass
    // `position: 'top-right'` (e.g. add-to-cart from the spare-parts carousel,
    // cart discount warnings) fell back to the library default `top-center` —
    // the center-vs-right inconsistency QA reported. Setting it here (before the
    // caller's `...options`) makes every toast right-aligned from a single place
    // while still letting a call site override if it ever needs to.
    position: 'top-right',
    ...options,
  };
};

export const getToast: GetToast = (message, ...props) => {
  if (typeof message === 'string') return ReactToast(message, getToastOptions(message.length, ...props));
  else return ReactToast(message, getToastOptions(130, ...props));
};
